import { useTranslation } from "react-i18next";
import { Badge } from "catalyst-ui-kit/badge";

/**
 * Small red "ANULIUOTA" marker shown next to an annulled document's name in
 * document lists (category files, related files, user profile documents).
 */
export default function AnnulledBadge() {
  const { t } = useTranslation();
  return (
    <Badge color="red" className="align-middle">
      {t("annulled_badge")}
    </Badge>
  );
}
